<template>
  <div v-if="errors.length > 0">
    <ul class="errors-list">
      <li v-for="error in errors" :key="error.code" class="item-error">
        {{ error.description }}
      </li>
    </ul>
  </div>
</template>

<script>
import { ModelStateErrors } from "Libs/core";
export default {
  data() {
    return {
      modelStateErrors: ModelStateErrors,
    };
  },
  computed: {
    errors() {
      let filteredErrors = [];
      this.errorTypes.length > 0
        ? (filteredErrors = this.modelStateErrors.filter(function (e) {
            return this.indexOf(e.type) >= 0;
          }, this.errorTypes))
        : (filteredErrors = this.modelStateErrors);
      return filteredErrors;
    },
  },
  props: {
    errorTypes: {
      type: Array,
      default: [],
    },
  },
};
</script>


<style lang="scss" scoped>
.errors-list {
  list-style: none;
  padding: 0;
  margin: 0;
  .item-error {
    color: #ff5252;
  }
}
</style>